import { z } from 'my-zod'
import { vehiclesModel } from './vehicles-model'
import { AdventuresVehicleProgramTypeEnum } from '../../internal'

export const vehicleAdventureView = vehiclesModel
  .augment({
    programType: AdventuresVehicleProgramTypeEnum,
    openBulletins: z.number().nullish(),
    openStopRides: z.number().nullish()
  })
  .omit({
    customAssetFamilyId: true,
    outfitterCustomAssetSerialNumber: true,
    corporateFleetResponsibleUser: true,
    corporateFleetProjectNumber: true,
    ibmiShippingDestination: true,
    ibmiOrderNumber: true,
    ibmiAssignedEmployeeEmail: true,
    ibmiAssignedEmployeeName: true,
    ibmiAssignedEmployeeNumber: true,
    ibmiEmployeeUnitStatus: true,
    ibmiIsShippable: true,
    ibmiYldHoldExists: true,
    ibmiHoldExists: true,
    ibmiSafetyBulletinExists: true,
    ibmiIsPrecertified: true,
    ibmiIsCompetitor: true
  })

export type vehicleAdventureView = z.infer<typeof vehicleAdventureView>
